import { get } from '../base'

/** 经纬度逆地理编码 */
export function reverseGeocode(lat: number, lng: number) {
  return get('/common/reverse-geocode', { params: { lat, lng } })
}

/** IP 自动解析城市 */
export function getIpLocationCity() {
  return get('/common/ip-location', {})
}

/**
 * 纯前端定位逆地理服务（高德地图）
 */
export const getGeoInfo = async (lat: number, lng: number) => {
  const lonLatString = `${lng},${lat}`
  const res = await fetch(
    `https://restapi.amap.com/v3/geocode/regeo?key=f7cf82899b809a753ff873d69febd9bb&location=${lonLatString}`
  )
  const data = await res.json()
  return data
}
